export const SITE_ORIGIN = "https://getcleaniq.com";
export const SOCIAL_IMAGE = `${SITE_ORIGIN}/cleaniq-og-data-flow.jpg`;
export const SOCIAL_IMAGE_WIDTH = "1200";
export const SOCIAL_IMAGE_HEIGHT = "630";
export const SOCIAL_IMAGE_ALT =
  "CleanIQ data quality engine transforming fragmented CRM records into clean structured data";
